import BottomFooter from './bottom-footer/index.vue'
const installComponents = [
  BottomFooter
]
export default installComponents
